module.exports = __webpack_public_path__ + "img/logo-wp.6db352c2.svg";